import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.zeroharmai.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

interface SeoProps {
  title: string;
  description: string;
  // Route path, e.g. "/about". Used for the canonical and og:url.
  path?: string;
  // Shorter description for social cards; defaults to description.
  socialDescription?: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
}

// Every page's title, description, canonical, Open Graph, and Twitter tags.
// Page-specific extras (article:* meta, JSON-LD) go in a separate <Helmet>.
export default function Seo({
  title,
  description,
  path,
  socialDescription = description,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}: SeoProps) {
  const url = path === undefined ? undefined : SITE_URL + path;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex" />}
      {url && !noindex && <link rel="canonical" href={url} />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={socialDescription} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={socialDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
